import useUserDiscount from "@components/_hooks/useUserDiscount";
import Typography from "@mui/material/Typography"
import dynamic from "next/dynamic"
import { useSelector } from "react-redux"
import { count, getBrand, getProductPricing, isDefined, money, vatPricing } from "../../config/helpers"
const PriceInfoTag = dynamic(() => import("../ProductComponent/PriceInfoTag"), {
    ssr: true,
});

const ProductPricing = dynamic(() => import("../ProductComponent/ProductCard/ProductPricing"), {
    ssr: true,
});

//adding new price for products with offer price tag
const ProductPriceContainer = (props) => {

    const {
        on_offer, 
        poa_price, 
        price_breaks, 
        product_price, 
        new_price, 
        template_page_settings = {},
        all_in_price
    } = props;

    const {hasProductDiscounts} = useUserDiscount();
    
    const discount_value = hasProductDiscounts();
    const VATFlag = useSelector((state) => state.globalReducer.VATFlag);
    const tax = useSelector((state) => state.globalReducer.tax);
    const pricing_model = useSelector((state) => state.globalReducer.pricing_model);
    
    const priceTag = () => {
        if(on_offer == 'yes'){
            if(poa_price == 'no'){
                if(price_breaks && count(price_breaks) > 0){
                    return <ProductPricing on_offer={on_offer} type="has_offer" original_price={money(product_price)} price={vatPricing(VATFlag, tax, product_price, all_in_price, discount_value, pricing_model)} template_page_settings={template_page_settings} />
                }
                else {
                    return <ProductPricing on_offer={on_offer} type="no_offer"original_price={money(product_price)}  price={vatPricing(VATFlag, tax, new_price, all_in_price, discount_value, pricing_model)} template_page_settings={template_page_settings} />
                }
            }
            else {
                <span>POA</span>
            }
        }
        else if(poa_price == 'no'){
            if(isDefined(price_breaks) && count(price_breaks) > 0){
                return  <ProductPricing type="has_offer" original_price={money(product_price)} price={vatPricing(VATFlag, tax, product_price, all_in_price, discount_value, pricing_model)} template_page_settings={template_page_settings}/>;
            }
            else {
                return <ProductPricing type="no_offer" original_price={money(product_price)} price={vatPricing(VATFlag, tax, product_price, all_in_price, discount_value, pricing_model)} template_page_settings={template_page_settings} />
            }
        }
        else {
            <span>POA</span>
        }
    }

    return (
        <Typography className="text-vertical">
            {priceTag()}
            {pricing_model == 1 && (
                <>
                    &nbsp;<PriceInfoTag title="Price includes delivery, build, takedown &amp; collection"/>
                </>
            )}
        {/* Long term hire section */}
        </Typography>
    )
}

export default ProductPriceContainer